/**
 * determine if the script is running within the node.js server side layer
 */
export function isPlatformNodeJS(): boolean {
  return (
    typeof process !== "undefined" &&
    Object.prototype.toString.call(process) === "[object process]"
  );
}
